export default __webpack_public_path__ + "static/media/ic-es.3370dbba.svg";